export default "__VITE_ASSET__Y5muwSgj__"